import { Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { BORDER, MUTED } from './footerStyles';

export const Copyright = () => (
  <Text
    color={MUTED}
    textStyle='bodySmallMedium'
    textAlign={{ base: 'center', md: 'start' }}
    w='100%'
    borderTopWidth='1px'
    borderTopColor={BORDER}
    pt={6}
  >
    <FormattedMessage
      id='footer.copyright'
      defaultMessage='© 2026 Ticket Zone. All rights reserved.'
    />
  </Text>
);
